/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
import axios from "axios";
import PerfectScrollbar from "react-perfect-scrollbar";
import PartListItem from "../../components/player/PartListItem";

class PartList extends Component {
  state = {};
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    this._getData();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _getData = async () => {
    const result = await this._getDataApi();
    const intReturn = result.data[0].intReturn;
    const partList = result.data[0].listData;

    if (intReturn === 0) {
      if (this._isMounted) {
        this.setState({
          partList,
        });
      }
    }
  };
  _getDataApi = () => {
    const { apiUrl } = this.props;
    const { contentPartSerial } = this.props.childProps;

    ////console.log(apiUrl + '/partList?contentPartSerial=' + contentPartSerial)
    return axios(apiUrl + "/partList?contentPartSerial=" + contentPartSerial)
      .then((response) => response)
      .catch((error) => {
        //console.log('화 별 작품목록을 로드 중 오류가 발생했습니다.')
      });
  };
  _renderItem = () => {
    const { onPlay, progress } = this.props.childProps;
    const { partList } = this.state;

    const list = partList.map((item, index) => {
      return (
        <PartListItem
          key={index}
          contentPartSerial={item.contentPartSerial}
          currentPartSerial={this.props.childProps.contentPartSerial}
          title={item.title}
          subTitle={item.subTitle}
          part={item.part}
          img={item.img}
          subPartSerial2={item.subPartSerial2}
          subPartSerial3={item.subPartSerial3}
          episode={item.episode}
          onClickPlay={onPlay}
          progress={progress}
        />
      );
    });

    return list;
  };
  _onHidePart = () => {
    const { onHidePart } = this.props.childProps;

    onHidePart();
  };
  _toggleWish = () => {
    const { toggleWish } = this.props.childProps;
    toggleWish();
  };
  render() {
    const { wishFlag } = this.props.childProps;
    const { partList } = this.state;
    return (
      <Fragment>
        <div className="vod_menu_pop">
          {partList ? (
            <Fragment>
              <h1>
                <span>
                  {partList[0].title.length > 25
                    ? partList[0].title.substr(0, 25) + "..."
                    : partList[0].title}
                </span>
                <a
                  style={{ cursor: "pointer" }}
                  className={wishFlag ? "on" : null}
                  onClick={this._toggleWish}
                ></a>
              </h1>
              <div className="vod_menu_group">
                <PerfectScrollbar>{this._renderItem()}</PerfectScrollbar>
              </div>
            </Fragment>
          ) : null}
        </div>

        {/*
                <div onClick = {this._onHidePart}>닫기</div>
                <div style={{display: 'flex'}}>
                   { partList ? this._renderItem() : null }
                </div>
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(PartList));
